module.exports = __webpack_public_path__ + "static/media/Icons-Toggle_on.ac423562.svg";